import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_PRIVATE_MESSAGE,
  GET_PRIVATE_MESSAGES,
  GET_PRIVATE_MESSAGES_BY_FILTER,
  GET_PRIVATE_MESSAGES_SEND_TO_CURRENT_USER,
  GET_PRIVATE_MESSAGES_SEND_FROM_CURRENT_USER,
  GET_COURSES_OF_PRIVATE_MESSAGES_CURRENT_STUDENT,
  GET_COURSES_OF_PRIVATE_MESSAGES_CURRENT_TEACHER,
  ADD_PRIVATE_MESSAGE,
  UPDATE_PRIVATE_MESSAGE,
  UPDATE_PRIVATE_MESSAGE_ALREADY_READ,
  DELETE_PRIVATE_MESSAGE,
} from '../../../../queries/modules/pm/private-message';

export async function getPrivateMessages(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_PRIVATE_MESSAGES,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setPrivateMessages', data.getPrivateMessages);
      context.commit('setSuccess', null);
      return data.getPrivateMessages
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getPrivateMessage(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_PRIVATE_MESSAGE,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', null);
      return data.getPrivateMessage
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getPrivateMessagesByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_PRIVATE_MESSAGES_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setPrivateMessages', data.getPrivateMessagesByFilter);
      context.commit('setSuccess', null);
      return data.getPrivateMessagesByFilter
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getPrivateMessagesSendToCurrentUser(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_PRIVATE_MESSAGES_SEND_TO_CURRENT_USER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      // context.commit('setPrivateMessagesSendTo', data.getPrivateMessagesSendToCurrentUser);
      context.commit('setSuccess', null);
      return data.getPrivateMessagesSendToCurrentUser
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getPrivateMessagesSendFromCurrentUser(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_PRIVATE_MESSAGES_SEND_FROM_CURRENT_USER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      // context.commit('setPrivateMessagesSendFrom', data.getPrivateMessagesSendFromCurrentUser);
      context.commit('setSuccess', null);
      return data.getPrivateMessagesSendFromCurrentUser
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getCoursesOfPrivateMessageCurrentStudent(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_COURSES_OF_PRIVATE_MESSAGES_CURRENT_STUDENT,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setCoursesOfPrivateMessage', data.getCoursesOfPrivateMessagesCurrentStudent);
      context.commit('setSuccess', null);
      return data.getCoursesOfPrivateMessagesCurrentStudent
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getCourseOfPrivateMessagesCurrentTeacher(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_COURSES_OF_PRIVATE_MESSAGES_CURRENT_TEACHER,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setCoursesOfPrivateMessage', data.getCoursesOfPrivateMessagesCurrentTeacher);
      context.commit('setSuccess', null);
      return data.getCoursesOfPrivateMessagesCurrentTeacher
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addPrivateMessage(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_PRIVATE_MESSAGE,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const privateMessages = [...context.state.privateMessagesSendFrom];
      privateMessages.unshift(data.addPrivateMessage);
      context.commit('setPrivateMessagesSendFrom', privateMessages);
      context.commit('setSuccess', newItemSuccess(data.addPrivateMessage.topic));

      return data.addPrivateMessage
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updatePrivateMessage(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_PRIVATE_MESSAGE,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.privateMessages.findIndex(item => item.id === data.updatePrivateMessage.id);
      const privateMessages = [
        ...context.state.privateMessages.slice(0, index),
        data.updatePrivateMessage,
        ...context.state.privateMessages.slice(index + 1)
      ];
      context.commit('setPrivateMessages', privateMessages);
      context.commit('setSuccess', updateItemSuccess(data.updatePrivateMessage.topic));

      return data.updatePrivateMessage
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updatePrivateMessageAlreadyRead(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_PRIVATE_MESSAGE_ALREADY_READ,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.privateMessages.findIndex(item => item.id === data.updatePrivateMessageAlreadyRead.id);
      const privateMessages = [
        ...context.state.privateMessages.slice(0, index),
        data.updatePrivateMessageAlreadyRead,
        ...context.state.privateMessages.slice(index + 1)
      ];
      context.commit('setPrivateMessages', privateMessages);
      context.commit('setSuccess', updateItemSuccess(data.updatePrivateMessageAlreadyRead.topic));

      return data.updatePrivateMessageAlreadyRead
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deletePrivateMessage(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_PRIVATE_MESSAGE,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.privateMessages.findIndex(item => item.id === data.deletePrivateMessage.id);
      const privateMessages = [
        ...context.state.privateMessages.slice(0, index),
        ...context.state.privateMessages.slice(index + 1)
      ];
      context.commit('setPrivateMessages', privateMessages);
      context.commit('setSuccess', deleteItemSuccess(data.deletePrivateMessage.topic));

      return data.deletePrivateMessage
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

